function NotFound() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1 style={{ borderBottom: "1px solid #d9d9d9" }}>404</h1>
      <p style={{ lineHeight: "150%" }}>
        페이지를 찾을 수 없습니다.
        <br />
        정상적인 링크로 접속해 주세요.
      </p>
    </div>
  );
}

export default NotFound;
